import html2pdf from "html2pdf.js";
import * as htmlToImage from 'html-to-image';

export class PledgeCanvasModule {
  initialize() {
    this.container = document.querySelector(".pledge-canvas");

    if (!this.container) return;

    this.downloadButton.addEventListener("click", () => this.downloadPDF());
    this.imageButtons.forEach(button => {
      button.addEventListener("click", (e) => this.createImage(e));
    });
  }

  get downloadButton() {
    return this.container.querySelector(".pledge-canvas-download");
  }

  get imageButtons() {
    return this.container.querySelectorAll(".pledge-create-image");
  }

  get pledgePdf() {
    return this.container.querySelector(".pledge-pdf");
  }

  async createImage(e) {
    const pledgeType = e.target.getAttribute("data-pledge-type");
    const pledgeDiv = document.querySelector(`.pledge-linkedin[data-pledge-type="${pledgeType}"]`);

    if (pledgeDiv) {
        const clone = pledgeDiv.cloneNode(true);
        clone.classList.remove("d-none");

        document.body.appendChild(clone);

        try {
            const dataUrl = await htmlToImage.toJpeg(clone,
              {
                quality: 0.6,
              }
            );
            const link = document.createElement("a");
            link.download = `pledge-${pledgeType}.jpg`;
            link.href = dataUrl;
            link.click();
        } catch (error) {
            console.error("Error creating image:", error);
        } finally {
            document.body.removeChild(clone);
        }
    }
}

  downloadPDF() {
    const options = {
      filename: "pledge.pdf",
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(this.pledgePdf).save();
  }
}
